// extracted by mini-css-extract-plugin
export default {"checkN1BannerSize":"ImagensCategorias_checkN1BannerSize__uGFku"};